import React from 'react';

import { Translate } from '../../helpers/translate';

export const homeAboutContent = [
    () => <Translate>Nvak Foundation is a 501c3 non-profit organization which empowers developing artists around the world to reach their full potential through world-class education, mentorship, and direct grants for critical needs.</Translate>,
    () => <Translate>Our Artist Care Program, which launched in January 2022, helps creators everywhere by giving them access to healthcare, dental and vocal care, mental health counseling, life coaching, 1:1 career mentorships, and more.</Translate>,
    () => <Translate>Not only does this work transform lives today, but builds a more diverse, inclusive and safe music industry for underrepresented, under-resourced artists tomorrow.</Translate>,
];
